<template>
    <div class="select">
        <select :value="value" @input="$emit('input',$event.target.value)">
            <option disabled value="">Selecciona</option>
            <option v-for="(option,index) in fieldProperties.content" :key="index">{{option}}</option>
        </select>
    </div>
</template>

<script>
import { inputProps } from '@/mixins/FormInputMixin'
export default {
  mixins: [inputProps],
  name: 'form-select'
}
</script>

<style>
</style>
